import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from './View' 

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    //position: 'relative',
    //height: '30vh',
    //minHeight: '240px'
  },
  title: {   
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '42px',//'min(6vh, 36px)',//'36px',

    //color: '#ffffff',
    color: '#454545',

    margin: '36px',
    zIndex: 5,

    '@media(max-height: 976px)': {
      fontSize: '32px',
    },
  },
  markersBar: {
    margin: '30px 36px 0',
  },
  marker: {
    width: '24px',
    height: '8px',
    borderRadius: '8px',
    marginRight: '8px',
    backgroundColor: theme.colors.secondary
  },
  current: {
    backgroundColor: theme.colors.primary
  },
  next: {
    backgroundColor: '#cfcfcf'
  }
}))

function Header (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })

  const getStyle = index => {
    if (index < props.index) return styles.marker
    else if (index === props.index) return `${styles.marker} ${styles.current}`
    else return `${styles.marker} ${styles.next}`
  }

  const arr = new Array(props.numOfSteps).fill(0)
  return (
    <View className={styles.root}>
      { props.showMarkers && (
        <View className={styles.markersBar}>
          { arr.map((value, index) => (<div key={index} className={getStyle(index)}></div>))}
        </View> 
      )}
      <View className={styles.title}>
        { props.title }
      </View>
    </View>
  )
}

export default Header